<template>
  <div>
    <a-upload :action="action"
              name="media"
              listType="picture-card"
              :fileList="fileList"
              @preview="handlePreview"
              :multiple="multiple"
              :accept="accept"
              @change="handleChange">
      <div v-if="fileList.length < max">
        <a-icon type="plus"/>
        <div class="ant-upload-text">{{ placeholder }}</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage"/>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: 'dol-upload-img-list',
  props: {
    value: {type: Array},                 //value
    url: {type: String, default: '/system/tool/file/save'},            //文件类型，可为空
    max: {type: Number, default: 3},             //最大上传数
    multiple: {type: Boolean, default: true},            //是否多选
    placeholder: {type: String, default: '上传图片'},
    paramsData: {type: Object},
    serverType: {type: String},
    accept: {type: String, default: '*'},            //允许上传类型
    maxSize: {type: Number, default: 1000},            //最大上传限制，单位K
  },
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      fileList: this.value,
      fileListInside: [],
    }
  },
  computed: {
    action() {
      const token = this.$store.state.userInfo && this.$store.state.userInfo.USER_ID || '10000001';
      let commonParams = {
        "SERVICE_TYPE": this.serverType,
        "USER_ID": token,
        "H5_CREATE_DATE": moment().format('YYYY-MM-DD HH:mm:ss'),
        "INPUT_PARAM":[this.paramsData],
      }
      let action = '/container-erp/UploadFileAPI';
      action += `?postData=${JSON.stringify(commonParams)}`
      return action;
    }
  },
  watch: {
    value(val) {
      this.updateData(val);
    }
  },
  methods: {
    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl || file.filePath;
      this.previewVisible = true
    },
    // 图片list有更新时触发（新增、删除、更改）
    handleChange({fileList}) {
      let flag = true, value = [];
      if(this.fileList.length < this.max){
        fileList.forEach((item, i) => {
          if (item.response) {
            value.push(item?.response?.data?.FILE_LIST?.[0])
            fileList[i].url = this.$Dolphin.path.filePath + item?.response?.data?.FILE_LIST?.[0]?.FILE_NAME;
            fileList[i].uid = item?.response?.data?.FILE_LIST?.[0]?.GUID_CODE;
          }else {
            value.push(item?.dataSource)
          }
          if (item?.status == 'done') {
            flag = true;
          }else {
            flag = false;
          }
        });
        this.fileList = fileList;
        // 确保上传完成后再写出文件list
        if (flag) {
          this.$emit('input', value)
        }
      }
    },
    //数据初始化
    updateData(val) {
      this.fileList = [];
      if(val && val.length){
        val.forEach((img, i) => {
          this.fileList.push({
            name: img.FILE_NAME,
            uid: img.uid || img.GUID_CODE,
            fileId: img.fileId || img.GUID_CODE,
            status: img.status || 'done',
            url: this.$Dolphin.path.filePath + img.FILE_NAME,
            dataSource: val[i],
          });
        });
      }
    },
  },
  created() {
    this.updateData(this.value);
  },
}
</script>
<style>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
